import get from 'lodash/get';

import { useStaticProps } from '../../../../context/static-props';

const mapFontSize = {
  mobile: 14,
  desktop: 16,
  tablet: 16,
};

const mapDecimalSymbol = {
  ',': 'comma',
  '.': 'dot',
};

export const AMOUNT_PLACEHOLDER = '{amount}';

/**
 * @param {Object} params
 * @param {string} params.epigraphText
 * @param {Array} params.values
 * @returns {Object}
 */
export const useProcessMoneyAmount = ({ epigraphText, values }) => {
  const { country, deviceType } = useStaticProps() || {};

  if (!epigraphText || !(values?.length > 0) || !country) {
    return {};
  }

  const { text } = values[0];
  const { decimal_separator, currency_id, currencies } = country;
  const currencySymbol = get(currencies, `${currency_id}.symbol`, null);
  const [before = '', after = ''] = epigraphText.split(AMOUNT_PLACEHOLDER) ?? [];
  const [fraction, cents] = text?.split(decimal_separator) ?? [];
  const fractionValue = fraction?.replace(currencySymbol, '')?.trim?.();
  const centsType = mapDecimalSymbol[decimal_separator] ?? 'comma';

  const size = mapFontSize[deviceType] ?? mapFontSize.desktop;

  return {
    before,
    after,
    fractionValue,
    cents,
    centsType,
    currency_id,
    size,
  };
};
